// extracted by mini-css-extract-plugin
module.exports = {"main":"Instruction_main__X-0jE","link":"Instruction_link__3O7xO"};